// network could be a string or number, so we find number in a string or return string
export const getNumOrStrFromStringChainId = (chainId: string) => {
  return isNaN(parseInt(chainId)) ? chainId : parseInt(chainId);
};
